import React, { useEffect, useRef, useState } from 'react'
import PaymentDetailsInfoNewHeader from './PaymentDetailsInfoNewHeader'
import useDataFetch from 'Common/useDataFetch/useDataFetch';
import { dropDownApis, MAX_FILE_SIZE_30MB, PAYMENT_LINE_ITEM_TYPES } from 'Common/Constants';
import NumberConversion from 'Utils/NumberConversion';
import { LuChevronUp, LuChevronDown, LuChevronRight, LuPlus, LuPaperclip, LuEye } from "react-icons/lu";
import FormatMomentDate from 'Utils/FormatMomentDate';
import { GiPaperClip } from 'react-icons/gi';
import Show from 'Components/Show/Show';
import { EXTENSION_NOT_ALLOWED, FILE_SIZE_MUST_BE_LESS_THAN_30MB, SAVED_SUCCESSFULLY } from 'Common/ToastConstants';
import { toast } from 'react-toastify';
import api from 'http';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import isNull from 'Utils/isNull';
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';
import PaymentNotes from './PaymentNotes';
import ConfirmationPopup from 'Popups/ConfirmationPopup/ConfirmationPopup';
import { RiDeleteBin6Line } from 'react-icons/ri';
import UserIcon from 'SVGS/UserIcon';
import ClockIcon from 'SVGS/ClockIcon';
import { useDispatch } from 'react-redux';
import { addPatient } from 'Redux/TabsSlice/TabsSlice';
import StatusPill from 'Components/StatusPill/StatusPill';
const allowedFileTypes = [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
];
const PaymentDetailsInfoNew = ({ setState, handlePayment, state, paymentId, paymentModel, setEditEnable, editEnable,
    getPaymentMain, setPaymentModel, validationModel, setValidationModel, handleRemoveAttachment, handleAttachmentChange,
    closeViewAttachment, openViewAttachment, handleApplyPayment, handlePaymentChange, viewAddAttachmentPopup,
    setViewAddAttachmentPopup }) => {
    const [expandedRow, setExpandedRow] = useState(() => (paymentModel?.isUnpostable ? '1' : null));
    const [expandedNotes, setExpandedNotes] = useState(false);
    const [expandedAttachments, setExpandedAttachments] = useState(false);
    const [loading, setLoading] = useState(false);
    const [notesCount, setNotesCount] = useState(0)
    const [notes, setNotes] = useState([]);
    const [deleteAttachmentConfirmation, setDeleteAttachmentConfirmation] = useState({
        status: false, attachmentId: null
    });
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();


    const { data: FindLocations } = useDataFetch(dropDownApis.pms.findLocations, "findLocations");

    //  ************* Add Note function ************
    const handleAddNoteClick = () => {
        if (!expandedNotes) {
            setExpandedNotes(true);
        }
        setTimeout(() => {
            window.dispatchEvent(new Event('triggerAddNote'));
        }, 100);
    };
    const handleDeleteAttachment = async () => {
        try {
            setLoading(true);
            const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/patientpayment/v2/DeletePaymentAttachment?attachmentId=${deleteAttachmentConfirmation.attachmentId}`);
            toast.success(response?.data.dataModel);
            getPaymentMain();
        } catch (error) {
            ErrorHandlingMessage(error);
        } finally {
            setLoading(false);
            setDeleteAttachmentConfirmation({ status: false, attachmentId: null });
        }
    };
    const deleteAttachment = (attachment) => {
        setDeleteAttachmentConfirmation({ status: true, attachmentId: attachment.id });
    };
    const handleAttachmentCancel = () => {
        setDeleteAttachmentConfirmation({ status: false, attachmentId: null });
    };


    const handleAddAttachment = async (e) => {
        const selectedFiles = Array.from(e.target.files);
        if (!selectedFiles.length) return;

        const allowedAttachments = [];

        for (const file of selectedFiles) {
            const fileType = file.type || file.name.split('.').pop();
            if (!allowedFileTypes.includes(fileType)) {
                toast.warning(EXTENSION_NOT_ALLOWED);
                continue;
            }

            if (file.size > MAX_FILE_SIZE_30MB) {
                toast.warning(FILE_SIZE_MUST_BE_LESS_THAN_30MB);
                continue;
            }

            // Convert to Base64
            const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => resolve(event.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });

            allowedAttachments.push({
                addedBy: "",
                updatedBy: "",
                updatedDate: "",
                inActive: false,
                inActiveReason: "",
                inActiveBy: "",
                inActiveDate: "",
                id: 0,
                paymentMainId: 0,
                paymentMain: "",
                fileName: file.name,
                url: "",
                fileBase64: base64,
            });
        }

        if (allowedAttachments.length === 0) return;

        try {
            setLoading(true)
            await api.post(`${process.env.REACT_APP_TC_PMS}/api/Payment/SavePayment`, {
                ...paymentModel,
                paymentAttachment: [
                    ...(Array.isArray(paymentModel?.paymentAttachment)
                        ? paymentModel.paymentAttachment
                        : []),
                    ...allowedAttachments,
                ]
            });
            toast.success(SAVED_SUCCESSFULLY);
            getPaymentMain()
        } catch (error) {
            ErrorHandlingMessage(error);
        } finally {
            setLoading(false)
            e.target.value = null;
        }
    };


    const handleAddAttachmentClick = () => {
        fileInputRef.current?.click();

    };

    const openPatient = () => {
        const obj = {
            active: true,
            id: paymentModel.patientId,
            subTab: "Overview",
            name: paymentModel.patientName,
            unsavedChanges: false,
            insuranceData: { status: false, editMode: false }
        }
        dispatch(addPatient(obj))
    }
    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/patientpayment/v2/FindPaymentNotes?PaymentMainid=${paymentId}`);
                setNotes(response?.data.dataModel);
                setNotesCount(response?.data.dataModel.length);
            } catch (error) {
                ErrorHandlingMessage(error);
            } finally {
                setLoading(false);
            }
        })();
    }, [paymentId]);

    // Keep row expanded by default when payment is unpostable
    useEffect(() => {
        if (paymentModel?.isUnpostable) {
            setExpandedRow('1');
        }
    }, [paymentModel?.isUnpostable]);

    // Helper function to format currency
    const formatCurrency = (value) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(value || 0);
    };

    // Calculate remaining balance
    const getRemainingBalance = () => parseFloat(state?.checkRemainingAmount || 0);

    const getAllocatedAmount = () => parseFloat(state?.allocatedAmount || 0);

    // Check if payment is over allocated
    const isOverAllocated = () => {
        return getRemainingBalance() < 0;
    };

    // Check if payment is fully allocated
    const isFullyAllocated = () => {
        const remaining = getRemainingBalance();
        // Consider fully allocated if remaining is 0 or very close to 0 (within 0.01)
        return Math.abs(remaining) < 0.01;
    };

    // Check if payment is under allocated
    const isUnderAllocated = () => {
        const remaining = getRemainingBalance();
        return remaining > 0.01; // More than 1 cent remaining
    };

    const shouldShowAllocationBanner = () => {
        return !(Math.abs(getRemainingBalance()) < 0.01 && Math.abs(getAllocatedAmount()) < 0.01);
    };

    // Helper functions to determine column visibility
    const isCheckPayment = () => paymentModel?.paymentMethod === 'Check';
    const isCashPayment = () => paymentModel?.paymentMethod === 'Cash';
    const shouldShowStripeAcct = () => !isCheckPayment() && !isCashPayment();
    const shouldShowCheckNumber = () => isCheckPayment();
    const shouldShowStatus = () => !isCashPayment();

    // Calculate colspan for expanded row
    const getExpandedRowColspan = () => {
        let cols = 1; // Expand button
        cols += 1; // Payment Method
        cols += 1; // Source
        if (shouldShowStripeAcct() || shouldShowCheckNumber()) cols += 1;
        cols += 1; // Amount
        cols += 1; // Date
        if (shouldShowStatus()) cols += 1;
        return cols;
    };
    return (
        <div className="bg-white border rounded-lg shadow-sm border-slate-200">
            <Show when={deleteAttachmentConfirmation.status}>
                <ConfirmationPopup
                    buttonTitle="Yes"
                    onCancel={handleAttachmentCancel}
                    onConfirm={handleDeleteAttachment}
                    subHeading="Are you sure you want to delete this attachment?"
                />
            </Show>
            <Show when={loading}>
                <FullPageLoader
                    allowFullScreen
                />
            </Show>
            <PaymentDetailsInfoNewHeader
                paymentId={paymentId}
                paymentModel={paymentModel}
                state={state}
                getPaymentMain={getPaymentMain}
                viewAddAttachmentPopup={viewAddAttachmentPopup}
                setViewAddAttachmentPopup={setViewAddAttachmentPopup}
                setValidationModel={setValidationModel}
                setPaymentModel={setPaymentModel}
                handleAttachmentChange={handleAttachmentChange}
                handleRemoveAttachment={handleRemoveAttachment}
                openViewAttachment={openViewAttachment}
                handleApplyPayment={handleApplyPayment}
                handlePaymentChange={handlePaymentChange}
                validationModel={validationModel}

            />
            <div className="border-t border-slate-200"></div>

            <div className="px-6 pt-6 pb-4">
                <div className="grid grid-cols-2 gap-x-8">
                    <div>
                        <div className="mb-1 text-xs font-medium tracking-wider uppercase text-slate-500">Patient Name</div>
                        <div onClick={openPatient} className="text-sm font-semibold cursor-pointer text-slate-800">{paymentModel?.patientName}</div>
                    </div>
                    <div>
                        <div className="mb-1 text-xs font-medium tracking-wider uppercase text-slate-500">Service Location</div>
                        <div className="text-sm font-medium text-slate-800">
                            {paymentModel?.locationId
                                ? FindLocations?.find(
                                    (item) => item.id === paymentModel?.locationId
                                )?.label
                                : ""}
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-6">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="bg-slate-50">
                            <tr className="border-b border-slate-200">
                                <th className="w-12"></th>
                                <th className="px-3 py-3 text-xs font-semibold tracking-wider text-left uppercase text-slate-600">Payment Method</th>
                                <th className="px-3 py-3 text-xs font-semibold tracking-wider text-left uppercase text-slate-600">Source</th>
                                {shouldShowCheckNumber() && (
                                    <th className="px-3 py-3 text-xs font-semibold tracking-wider text-left uppercase text-slate-600">Check Number</th>
                                )}
                                {shouldShowStripeAcct() && (
                                    <th className="px-3 py-3 text-xs font-semibold tracking-wider text-left uppercase text-slate-600">Stripe Acct</th>
                                )}
                                <th className="px-3 py-3 text-xs font-semibold tracking-wider text-left uppercase text-slate-600">Amount</th>
                                <th className="px-3 py-3 text-xs font-semibold tracking-wider text-left uppercase text-slate-600">Date</th>
                                {shouldShowStatus() && (
                                    <th className="px-3 py-3 text-xs font-semibold tracking-wider text-left uppercase text-slate-600">Status</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="transition-colors border-b border-slate-100 hover:bg-slate-50">
                                <td className="px-3 py-3">
                                    <button
                                        onClick={() => setExpandedRow(expandedRow === '1' ? null : '1')}
                                        className="p-1 transition-colors rounded hover:bg-slate-100"
                                    >
                                        {expandedRow === '1' ? (
                                            <LuChevronUp className="w-4 h-4 text-slate-400" />
                                        ) : (
                                            <LuChevronDown className="w-4 h-4 text-slate-400" />
                                        )}
                                    </button>
                                </td>
                                <td className="px-3 py-3 text-sm text-slate-800">{paymentModel.paymentMethod}</td>
                                <td className="px-3 py-3 text-sm text-slate-700">{['Check', 'Cash'].includes(paymentModel.paymentMethod) ? 'External' : paymentModel.paymentSource}</td>
                                {shouldShowCheckNumber() && (
                                    <td className="px-3 py-3 text-sm text-slate-700">{paymentModel.checkNumber || '-'}</td>
                                )}
                                {shouldShowStripeAcct() && (
                                    <td className="px-3 py-3 text-sm text-slate-700">
                                        {paymentModel.stripeAccountName}
                                    </td>
                                )}
                                <td className="px-3 py-3 text-sm font-semibold text-left text-slate-800">{NumberConversion(paymentModel?.paidAmount)}</td>
                                <td className="px-3 py-3 text-sm text-slate-700">{FormatMomentDate(paymentModel?.receivedDate)}</td>
                                {shouldShowStatus() && (
                                    <td className="px-3 py-3 text-sm text-slate-700">
                                        <span className={`inline-flex items-center px-3 py-1 mt-1 capitalize rounded text-xs font-semibold  ${paymentModel.ccTransactionStatus ? 'bg-green-100 text-green-700' : ''}`}>
                                            {paymentModel.ccTransactionStatus || '-'}
                                        </span>
                                    </td>
                                )}
                            </tr>
                            {expandedRow === '1' && (
                                <tr className="bg-slate-50">
                                    <td colSpan={getExpandedRowColspan()} className="px-6 py-4">
                                        <div className="space-y-4">
                                            {/* Line Items */}
                                            <div>
                                                <h4 className="mb-3 text-sm font-semibold text-slate-800">Line Items</h4>
                                                <div className="overflow-hidden bg-white border rounded-lg border-slate-200">
                                                    <table className="w-full text-sm">
                                                        <thead className="bg-slate-50">
                                                            <tr className="border-b border-slate-200">
                                                                <th className="px-3 py-2 text-xs font-medium text-left text-slate-600">Type</th>
                                                                <th className="px-3 py-2 text-xs font-medium text-left text-slate-600">Description</th>
                                                                <th className="px-3 py-2 text-xs font-medium text-left text-slate-600">Date of Service</th>
                                                                <th className="px-3 py-2 text-xs font-medium text-right text-slate-600">Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {paymentModel.lineItems?.map((row) => {
                                                                const itemType = PAYMENT_LINE_ITEM_TYPES.find((item) => item.value === row.itemType)
                                                                return (
                                                                    <tr className="border-b border-slate-100">
                                                                        <td className="px-3 py-2 text-slate-700">{itemType?.label}</td>
                                                                        <td className="px-3 py-2 text-slate-700">{itemType?.label === 'Copay' ? 'Office Visit Copay' : row.itemDescription}</td>
                                                                        <td className="px-3 py-2 text-slate-700">{FormatMomentDate(row.serviceDate)}</td>
                                                                        <td className="px-3 py-2 font-semibold text-right text-slate-800">
                                                                            <Show when={row.amount < 0} fallback={<span>{NumberConversion(row.amount)}</span>}>
                                                                                <StatusPill variant="failed">{NumberConversion(row.amount)}</StatusPill>
                                                                            </Show>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                            <tr className="border-b border-slate-100">
                                                                <td className="px-3 py-2 font-semibold text-slate-900">Total</td>
                                                                <td className="px-3 py-2 text-slate-700"></td>
                                                                <td className="px-3 py-2 text-slate-700"></td>
                                                                <td className="px-3 py-2 text-xl font-bold text-right text-slate-900 ">{NumberConversion(paymentModel?.paidAmount)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            {/* Notes - Collapsible */}
                                            <div>
                                                <div className="flex items-center justify-between mb-2">
                                                    <button
                                                        onClick={() => setExpandedNotes(!expandedNotes)}
                                                        className="flex items-center gap-2 px-2 py-1 text-left transition-colors rounded hover:bg-white"
                                                    >
                                                        {expandedNotes ? (
                                                            <LuChevronDown className="w-4 h-4 text-slate-400" />
                                                        ) : (
                                                            <LuChevronRight className="w-4 h-4 text-slate-400" />
                                                        )}
                                                        <h4 className="text-sm font-semibold text-slate-800">
                                                            Notes<span className="ml-1.5 text-slate-500 font-normal">{`${notesCount ? `(${notesCount})` : ""}`}</span>
                                                        </h4>
                                                    </button>
                                                    <button
                                                        onClick={handleAddNoteClick}
                                                        className="flex items-center gap-1 px-3 py-1 text-xs font-medium transition-colors bg-white border rounded text-slate-700 hover:text-slate-900 border-slate-300 hover:bg-slate-50"
                                                    >
                                                        <LuPlus className="w-3 h-3" />
                                                        Add
                                                    </button>
                                                </div>
                                                {expandedNotes && (
                                                    <div className="p-4 bg-white border rounded-lg border-slate-200">
                                                        <PaymentNotes
                                                            paymentId={paymentId}
                                                            setNotesCount={setNotesCount}
                                                            setNotes={setNotes}
                                                            notes={notes}
                                                        />

                                                        {/* notes goes here */}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Attachments - Collapsible */}
                                            <div>
                                                <input
                                                    ref={fileInputRef}
                                                    type="file"
                                                    onChange={handleAddAttachment}
                                                    className="hidden"
                                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif"
                                                />
                                                <div className="flex items-center justify-between mb-2">
                                                    <button
                                                        onClick={() => setExpandedAttachments(!expandedAttachments)}
                                                        className="flex items-center gap-2 px-2 py-1 text-left transition-colors rounded hover:bg-white"
                                                    >
                                                        {expandedAttachments ? (
                                                            <LuChevronDown className="w-4 h-4 text-slate-400" />
                                                        ) : (
                                                            <LuChevronRight className="w-4 h-4 text-slate-400" />
                                                        )}
                                                        <h4 className="text-sm font-semibold text-slate-800">
                                                            Attachments{paymentModel?.paymentAttachment && <span className="ml-1.5 text-slate-500 font-normal">{`(${paymentModel?.paymentAttachment?.length})`}</span>}
                                                        </h4>
                                                    </button>
                                                    <button
                                                        onClick={handleAddAttachmentClick}
                                                        className="flex items-center gap-1 px-3 py-1 text-xs font-medium transition-colors bg-white border rounded text-slate-700 hover:text-slate-900 border-slate-300 hover:bg-slate-50"
                                                    >
                                                        <LuPlus className="w-3 h-3" />
                                                        Add
                                                    </button>
                                                </div>
                                                {expandedAttachments && (
                                                    <div className="p-4 bg-white border rounded-lg border-slate-200">
                                                        {isNull(paymentModel?.paymentAttachment) ? (
                                                            <div className="flex items-center justify-center py-8 text-sm text-slate-500">
                                                                <LuPaperclip className="w-4 h-4 mr-2" />
                                                                No attachments
                                                            </div>
                                                        ) : (
                                                            <div className="space-y-2">
                                                                {paymentModel.paymentAttachment.map((attachment, index) => (
                                                                    <div key={attachment.id} className='p-3 border rounded-lg bg-slate-50 border-slate-200'>
                                                                        <div
                                                                            className="flex items-center justify-between"
                                                                        >
                                                                            <div className="flex items-center flex-1 gap-3">
                                                                                <GiPaperClip className="w-4 h-4 text-slate-400" />
                                                                                <div className="flex-1">
                                                                                    <div className="text-sm font-medium text-slate-700">{attachment.fileName}</div>
                                                                                    <div className="text-xs text-slate-500">
                                                                                        {FormatMomentDate(attachment.addedDate)}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <button
                                                                                onClick={() => openViewAttachment(attachment, index)}
                                                                                className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                                                                                title="View attachment"
                                                                            >
                                                                                <LuEye className="w-4 h-4" />
                                                                            </button>
                                                                            <button
                                                                                onClick={() => deleteAttachment(attachment)}
                                                                                className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                                                                                title="Delete attachment"
                                                                            >
                                                                                <RiDeleteBin6Line className="w-4 h-4" />
                                                                            </button>
                                                                        </div>
                                                                        <div className="flex gap-2 pt-2 text-xs text-slate-500">
                                                                            <div className="flex gap-1">
                                                                                <UserIcon size={12} />
                                                                                <div className='flex items-end' >{attachment.addedBy}</div>
                                                                            </div>
                                                                            <span>•</span>
                                                                            <div className="flex gap-1">
                                                                                <ClockIcon size={12} />
                                                                                <span className='flex items-end' >{FormatMomentDate(attachment.addedDate)}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Payment Summary - Below Table - hidden when payment is unpostable */}
                {!paymentModel?.isUnpostable && (
                    <div className="mt-6">
                        <div className="mb-3 text-sm font-semibold text-slate-800">Allocation Summary</div>
                        <div className="p-5 border rounded-lg bg-slate-50 border-slate-200">
                            <div className="grid grid-cols-3 gap-6">
                                <div>
                                    <div className="mb-1 text-xs text-slate-600">Payment amount</div>
                                    <div className="text-lg font-bold text-slate-800">{NumberConversion(paymentModel?.paidAmount)}</div>
                                </div>
                                <div>
                                    <div className="mb-1 text-xs text-slate-600">Amount allocated</div>
                                    <div className="text-lg font-semibold text-slate-800">{NumberConversion(state?.allocatedAmount)}</div>
                                </div>

                                <div>
                                    <div className="mb-1 text-xs font-medium text-slate-700">Remaining</div>
                                    <div className={`text-xl font-bold ${isOverAllocated()
                                        ? 'text-red-600'
                                        : isFullyAllocated()
                                            ? 'text-green-600'
                                            : 'text-amber-700'
                                        }`}>
                                        {formatCurrency(getRemainingBalance())}
                                    </div>
                                </div>
                            </div>

                            {shouldShowAllocationBanner() && isOverAllocated() && (
                                <div className="flex items-start gap-2 p-3 mt-4 border border-red-300 rounded-lg bg-red-50">
                                    <svg className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                    <span className="flex items-end text-xs font-medium leading-tight text-red-800">Allocation amount exceeds the Payment amount.</span>
                                </div>
                            )}

                            {shouldShowAllocationBanner() && isUnderAllocated() && (
                                <div className="flex gap-2 p-3 mt-4 bg-white border rounded-lg border-amber-300">
                                    <svg className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                    </svg>
                                    <span className="flex items-end text-xs leading-tight text-amber-800">Payment must be fully allocated to service lines</span>
                                </div>
                            )}

                            {shouldShowAllocationBanner() && isFullyAllocated() && (
                                <div className="flex gap-2 p-3 mt-4 border border-green-300 rounded-lg bg-green-50">
                                    <svg className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                    </svg>
                                    <span className="flex items-end text-xs font-medium leading-tight text-green-800">Payment fully allocated</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>


        </div>
    )
}

export default PaymentDetailsInfoNew